<!-- eslint-disable vue/no-mutating-props -->
<template>
  <el-rate
    v-model="model[prop]"
    v-bind="innerAttrs"
    :disabled="disabled"
    @change="handleSwitchChange"
  />
</template>

<script lang="ts">
export default { inheritAttrs: false }
</script>

<script setup lang="ts">
import { useFormItem } from '../util'

const props = withDefaults(
  defineProps<{
    model: Record<string, any>
    prop: string
    disabled?: boolean
    beforeChange?: Function
    activeValue?: any
    inactiveValue?: any
  }>(),
  {
    disabled: false,
    activeValue: true,
    inactiveValue: false
  }
)

// 当值为['', null, undefined]，默认值调整为false
if (['', null, undefined].includes(props.model[props.prop])) {
  props.model[props.prop] = props.inactiveValue
}

const { app, innerAttrs, handleChange } = useFormItem(props, {
  customeChangeEvent: true
})

function handleSwitchChange(val: any) {
  handleChange(val)
}
</script>
